module.exports = __webpack_public_path__ + "static/media/21.9aa06c99.jpg";